<template>
   <div id="organismForm" class="col-12 my-4">
      <p class="mb-2 text-left title-group">Campos do formulário</p>
      <draggable
         :list="totalForm" 
         @start="drag=true"
         @end="drag=false"
         v-bind="{ handle: '.handle'}"
         :force-fallback="true"
      >
         <div class="row justify-content-center" v-for="(item, index) in totalForm" :key="index">
            <div class="col-12 text-left my-2">
               <div class="card px-4 py-3">
                  <div class="row justify-content-between mx--4 header-card">
                     <div class="col-auto text-left handle pr-0">
                        <i class="fal fa-bars opacity-50"></i>
                     </div>
                     <div class="col text-left" v-b-toggle="'collapse-'+index">
                        <p class="m-0">{{verifyTitle(item.title)}}</p>
                     </div>
                     <div class="col-4 col-md-auto text-right list-actions">
                        <i class="fal fa-pencil-alt" v-b-toggle="'collapse-'+index"></i>
                        <i class="fal fa-trash-alt" @click="removeItem(index)"></i>
                     </div>
                  </div>
                  <b-collapse :id="'collapse-'+index">
                     <b-card-body class="p-0">
                        <div class="row mx-0 py-3 mt-3 align-items-center">
                           <div class="col-12 col-md-6 form-group">
                              <label>Nome do campo</label>
                              <input v-model="item.title" @keyup="verifyLength(item.title)" type="text" class="form-control"/>
                              <span class="alert-message" v-if="item.title && item.title.length == 0">Não pode estar vazio</span>
                           </div>
                           <div class="col-12 col-md-6 form-group">
                              <label>Tipo de campo</label>
                              <select class="form-control" v-model="item.type">
                                 <option value="text">Texto</option>
                                 <option value="email">E-mail</option>
                                 <option value="date">Data</option>
                                 <!-- <option value="file">Arquivo</option> -->
                                 <option value="tel">Telefone</option>
                                 <option value="textarea">Área de texto</option>
                                 <option value="option">Lista de Opções</option>
                                 <option value="text">Localização</option>
                                 <option value="time">Horas</option>
                              </select>
                           </div>
                           <div 
                              class="col-12 col-md-6 form-group"
                              v-if="item.type == 'option'">
                              <label>Cadastre as opções</label>
                              <div>
                              <div @click="addInputSelect(item)" class="form-group border-dashed cursor-pointer">Adicione uma nova opção +</div>
                              <div  
                                 class="d-flex align-items-center"
                                 type="text"
                                 v-for="input,index in item.value" 
                                 :key="'input'+index" >
                                 <input
                                    v-model="item.value[index]" 
                                    class="form-control" 
                                    placeholder="Digite uma opção..."
                                    > 
                                    <i class="fal fa-trash-alt cursor-pointer p-1" @click="removeItemSelect(item,index)"></i>
                                 </div>
                              </div>
                           </div>  
                           <div 
                              class="col-12 col-md-6 form-group" 
                              v-if="item.type != 'option'">
                              <label>Texto de exemplo</label>
                                 <input type="text" class="form-control" v-model="item.placeholder" placeholder="Este é um texto de exemplo">
                           </div>
                           <div class="col-12 col-md-6 form-group">
                              <label>Largura</label>
                              <select class="form-control" v-model="item.size">
                                 <option value="6">Meia linha</option>
                                 <option value="12">Linha toda</option>
                              </select>
                           </div>
                           <div class="col-12 col-md-6 form-group">
                              <input type="checkbox" :id="'required-'+index" v-model="item.required">
                              <label :for="'required-'+index">Obrigatório</label>
                           </div>
                        </div>
                     </b-card-body>
                  </b-collapse>
               </div>
            </div>
         </div>
      </draggable>
      <div class="row mt-2 text-right">
         <div class="col-12">
            <button class="btn px-4 btn-primario btn-small" @click="addNewInput">Novo campo</button>
         </div>
      </div>
      <div>
         <p v-b-toggle="'advanced-options'" class="mb-2">
            <button 
               v-b-tooltip.hover
               title="Você customiza opções mais avançadas como a mensagem depois do envio, redicionamentos ou o texto do botão do formulário"
               class="btn btn-transparent" 
               id="btnOpcoes">
               <i class="fal fa-cog"></i> opções avançadas
            </button>
         </p>
      </div>
      <b-collapse :id="'advanced-options'">
         <div class="row justify-content-center mt-2 text-left">
            <div class="col-12">
               <p class="title-group">Texto do botão de enviar</p>
            </div>
            <div class="col-12 text-left">
               <input type="text" class="form-control" @keyup="verifyLength(buttonOptions)" v-model="buttonOptions" placeholder="Insira o texto aqui">
            </div>
         </div>
         <div class="row justify-content-center mt-4 text-left">
            <div class="col-12">
               <p class="title-group">Mensagem de sucesso após envio</p>
            </div>
            <div class="col-12 text-left">
               <input type="text" class="form-control" @keyup="verifyLength(successMessage)" v-model="successMessage" placeholder="Insira a mensagem aqui">
            </div>
         </div>

         <div class="row justify-content-center mt-4 text-left">
            <div class="col-12">
               <p class="title-group">URL Redirecionamento <small>(caso em branco, vai continuar na mesma página)</small></p>
            </div>
            <div class="col-12 text-left">
               <input type="text" class="form-control" @keyup="verifyLength(successMessage)" v-model="urlRedirect" placeholder="Insira a url aqui">
            </div>
         </div>
         <div class="row justify-content-center mt-4 text-left" v-if="this.$store.state.application.id == 5">
            <div class="col-12">
               <p class="title-group">Receber envios desse formulário em um email personalizado?</p>
            </div>
            <div class="col-12 text-left">
               <input 
                  type="text" 
                  class="form-control" 
                  v-model="emailReply" 
                  placeholder="Insira o email aqui"
                  :application="this.$store.state.application.id"
               >
               <small>Caso esteja vazio, vai para o email cadastrado no seu painel de oportunidades</small>
            </div>
         </div>
      </b-collapse>
      <alertScreen 
         :showAlertScreen="this.showAlert"
         :alertTitle="'Remover campo'"
         :alertText="'Deseja realmente remover este campo?'"
         @returnAlertScreen="removeInput($event)"
      />
      <alertScreen 
         :showAlertScreen="this.showAlertErrorDelete"
         :hideCancel="true"
         :confirmText="'Ok, voltar'"
         :alertTitle="'Não foi possivel remover'"
         :alertText="'É necessário pelo menos um campo de telefone ou email'"
         @returnAlertScreen="showAlertErrorDelete = false"
      />
   </div>

</template>

<script>
   import draggable from 'vuedraggable';
   import alertScreen from '../molecules/AlertScreen'
   export default {
      name: "organismForm",
      props: {
         formContent:{
            type: Object,
            required: false
         }
      },
      data(){
         return{
            showAlert: false,
            showAlertErrorDelete: false,
            itemToRemove: '',
            totalForm: [],
            buttonOptions: '',
            successMessage: '',
            urlRedirect: '',
            emailReply: ''
         }
      },
      created(){
         this.totalForm = this.formContent.frameContent.content;
         this.buttonOptions = this.formContent.frameContent.submit;
         this.urlRedirect = this.formContent.frameContent.redirect;
         this.emailReply = this.formContent.frameContent.emailReply;

         if(this.formContent.frameContent.message){
            this.successMessage = this.formContent.frameContent.message;
         }else{
            this.successMessage = "Mensagem enviada com sucesso";
         }
      },
      watch:{
         totalForm(){
            if(this.totalForm.length == 0){
               this.$store.commit("BLOCK_POST", true);
            }else{
               for (let i = 0; i < this.totalForm.length; i++) {
                  this.totalForm[i].name = i;
               }
               this.$emit('updateForm', this.totalForm);
               this.$store.commit("BLOCK_POST", false);
            }
         },
         buttonOptions(){
            if(this.buttonOptions){
               this.$emit('updateButton', this.buttonOptions);
            }
         },
         successMessage(){
            if(this.successMessage){
               this.$emit('updateMessage', this.successMessage)
            }
         },
         urlRedirect(){
            if(this.urlRedirect){
               this.$emit('updateRedirect', this.urlRedirect)
            }
         },
         emailReply(){
            if(this.emailReply){
               this.$emit('updateEmailReply', this.emailReply)
            }
         }
      },
      methods:{
         addInputSelect(item){
            if(!item.value){
               item.value= []
            }
            item.value.push('')
            return item
         },
         verifyLength(name){
            if(name.length == 0){
               this.$store.commit("BLOCK_POST", true);
            }else{
               this.$store.commit("BLOCK_POST", false);
            }
         },
         verifyTitle(title){
            if(title){
               return title
            }else{
               return "Campo vazio"
            }
         },
         addNewInput(){
            this.totalForm.push({
               "type" : "text",
               "title" : "Novo Campo",
               "name" : this.totalForm.length,
               "placeholder" : "",
               "value" : '',
               "required" : false,
               "visible" : true,
               "size" : 12,
            })
            setTimeout(() => {
               this.$root.$emit('bv::toggle::collapse', 'collapse-'+(this.totalForm.length-1));
            }, 300);
         },
         removeItem(index){
            this.itemToRemove = index;
            if (!this.checkIfCanDelete(index)) {
               this.showAlertErrorDelete = true;
            } else {
               this.showAlert = true   
            }
         },
         removeItemSelect(item,index){
            item.value.splice(index,1)
         },
         removeInput(event){
            if(event){
               this.totalForm.splice(this.itemToRemove, 1);
               this.itemToRemove = ''
            }else{
               this.itemToRemove = ''
            }
            this.showAlert = false
         },
         /* check if can delete, at least will have 1 input with type telephone or email */
         checkIfCanDelete(index) {
            let canDelete = false;
            for (let i = 0; i < this.totalForm.length; i++) {
               if (i != index) {
                  if (this.totalForm[i].type == 'email' || this.totalForm[i].type == 'tel') {
                     canDelete = true;
                  }
               }
            }
            return canDelete;
         }

      },
      components:{
         draggable,
         alertScreen
      }
   }
</script>

<style scoped>
   .header-card i, .header-card p{
      cursor: pointer;
   }
   .list-actions i{
      margin-left: 10px;
      cursor: pointer;
   }
   .card .form-control{
      padding-left: 0;
      padding-right: 0;
   }
   .card .form-group label{
      margin-bottom: 0;
      font-size: 0.8rem;
      font-weight: 700;
      color: #777;
   }
   .alert-message{
      font-size: 0.8rem;
      color: #f22;
   }
   .title-group{
      font-weight: 700;
      margin: 0;
   }
   input[type=checkbox] + label {
      display: block;
      margin: 0.2em;
      cursor: pointer;
      padding: 0.2em;
   }

   input[type=checkbox] {
      display: none;
   }

   input[type=checkbox] + label:before {
      content: "\2714";
      border: 1px solid #000;
      border-radius: 0.2em;
      display: inline-block;
      width: 1.3rem;
      height: 1.3rem;
      padding-left: 0.3em;
      padding-bottom: 0.3em;
      margin-right: 10px;
      vertical-align: bottom;
      color: transparent;
      transition: .2s;
   }

   input[type=checkbox] + label:active:before {
      transform: scale(0.2);
   }

   input[type=checkbox]:checked + label:before {
      background-color: var(--main-color);
      border-color: var(--main-color);
      color: #fff;
   }

   input[type=checkbox]:disabled + label:before {
      transform: scale(1);
      border-color: #aaa;
   }

   input[type=checkbox]:checked:disabled + label:before {
      transform: scale(1);
      background-color: var(--main-color);
      border-color: var(--main-color);
   }
   .border-dashed{
      border-style: dashed;
      margin-bottom: 5px;
      border-width: 1px;
      text-align: center;
   }

   #advanced-options {
      padding: 10px 15px;
      background: #f5f5f5;
      position: relative;
   }

   div#advanced-options::before {
      content: "";
      position: absolute;
      top: -8px;
      left: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid whitesmoke;
   }

   .not-collapsed .btn-transparent {
      background: #f5f5f5;
   }

   .form-control {
      background: transparent;
   }
</style>



// WEBPACK FOOTER //
// src/components/organisms/Form.vue